import { C } from '../../data/tokens.js';
import { Ico } from '../Ico.jsx';

export function AttachClientModal({
  attachClientTo, setAttachClientTo, clients, reportHistory, attachReportToClient, setEditingClient
}) {
  if (!attachClientTo) return null;

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="modal-title" style={{ position: "absolute", inset: 0, background: "rgba(28,28,40,0.5)", backdropFilter: "blur(8px)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={() => setAttachClientTo(null)} onKeyDown={e => { if (e.key === "Escape") setAttachClientTo(null); }}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.bg1, border: `1px solid ${C.border}`, borderRadius: 18, padding: "24px 22px", width: "100%", maxWidth: 340, boxShadow: "0 24px 64px rgba(0,0,0,0.6)", maxHeight: "70vh", overflowY: "auto" }}>
        <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: C.ghost, marginBottom: 6 }}>Assign to client</div>
        <div id="modal-title" style={{ fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 700, color: C.white, marginBottom: 16 }}>
          {reportHistory.find(r => r.id === attachClientTo)?.addr}
        </div>
        {clients.length > 0 && clients.map(c => (
          <div key={c.id} onClick={() => { attachReportToClient(attachClientTo, c.id); setAttachClientTo(null); }}
            style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 10, cursor: "pointer", marginBottom: 6 }}>
            <Ico n="user" size={14} color={C.muted} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: C.offwhite }}>{c.name}</div>
              {c.phone && <div style={{ fontSize: 10, color: C.ghost }}>{c.phone}</div>}
            </div>
            <Ico n="arrowR" size={12} color={C.ghost} />
          </div>
        ))}
        <button onClick={() => setEditingClient({ name: "", phone: "", email: "", address: reportHistory.find(r => r.id === attachClientTo)?.fullAddress || "", notes: "" })}
          style={{ width: "100%", padding: "12px 0", borderRadius: 10, background: "none", border: `1.5px dashed ${C.border}`, color: C.muted, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6, marginTop: 4, fontFamily: "'DM Sans',sans-serif" }}>
          <Ico n="plus" size={14} color={C.ghost} /> New client
        </button>
      </div>
    </div>
  );
}
